import { useEffect, useState } from 'react';
import { Buildings } from '../../data/buildings';
import { useGame } from '../../data/gameContext';
import './town.css';
import Tumbleweed from './tumbleweed';
import { ETownSize } from '../../data/town';
import { GetRandomNumber } from '../../helper/common';
type TTumbleweedInstance = {
    Id: number;
    Top: number;
  };
export default function TownView() {
    const {gameState, updateGameState} = useGame();
      
      const [tumbleweeds, setTumbleweeds] = useState<TTumbleweedInstance[]>([]);
      

      useEffect(() => {
        const getRandomInterval = () => Math.random() * (30000 - 3000) + 3000;

        const spawnTumbleweed = () => {
          setTumbleweeds((prev) => {
            if (prev.length >= 30) return prev; 
            
            const newWeed: TTumbleweedInstance = {
              Id: Date.now(),
              Top: 330 + GetRandomNumber(30) - 20, 
            };
            
            return [...prev, newWeed];
          });
            
          setTimeout(() => {
            setTumbleweeds((prev) => prev.slice(1));
          }, 20000);

          setTimeout(spawnTumbleweed, getRandomInterval());
        };

        const initialTimeout = setTimeout(spawnTumbleweed, getRandomInterval());

        return () => clearTimeout(initialTimeout);
      
      }, []);
      

    //find the town we are in which we will need for the buildings
    const town = gameState.GameTowns.find((t) => t.Location.x === gameState.PlayerCharacter?.Location.x && t.Location.y === gameState.PlayerCharacter?.Location.y);
    
    return (
      <div className='town-container' style={{ position: 'relative', width: '1920px', height: '600px', overflowX: 'auto' }}>
          <img
              src='/images/town.png'
              alt='town'
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          />
  
          {town?.Buildings.map((b, index) => (
              <div
                  key={`${b.Name}-${index}`}
                  className={`building-overlay ${b.Size === ETownSize.Small ? 'available' : 'disabled'}`}
                  style={{
                      position: 'absolute',
                      top: b.Top,
                      left: b.Left,
                      width: b.Width,
                      height: b.Height,
                      cursor: 'pointer',
                  }}
                  title={b.Name}
                  onClick={() => updateGameState({ Phase: b.Name })}
              >
                  <img
                      src='/images/locations/Desert.png'
                      alt={b.Name}
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
              </div>
          ))}
  
          {tumbleweeds.map((weed) => (
              <Tumbleweed key={weed.Id} top={weed.Top} />
          ))}
      </div>
  );
  
}